export default defineNuxtRouteMiddleware((to) => {
  const hasQueryParams = Object.keys(to.query).length > 0

  if (hasQueryParams) {
    useHead({
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
      ],
    })
  }
})
